import React, { FC, memo, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userSelector } from '../../redux/user/selector';
import { useTranslation } from 'react-i18next';
import { useIsKeyBoardShown } from '../../shared';
import useToast from '../../context/ToastContext/ToastContext';
import { updateUserPersonalData } from '../../api/user';
import { setUser } from '../../redux/user/reducer';
import { ScreenInputFormFeature } from '@mindly/ui-components';

type ProfileLastNameWidgetProps = {
  onSuccess?: (value: string) => void;
};

const ProfileLastNameWidget: FC<ProfileLastNameWidgetProps> = ({ onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);

  const user = useSelector(userSelector);

  const { t } = useTranslation('auth');
  const isKeyboardShown = useIsKeyBoardShown();
  const dispatch = useDispatch();
  const { showToast } = useToast();

  const handleSubmit = useCallback(
    async (value: string) => {
      try {
        setIsLoading(true);
        const { data, error, message } = await updateUserPersonalData({
          last_name: value,
        });

        if (error) {
          throw new Error(message ? t(message) : 'Something went wrong');
        }

        dispatch(setUser(data));
        onSuccess?.(data.last_name);
      } catch (e: any) {
        showToast({ message: e?.message });
      } finally {
        setIsLoading(false);
      }
    },
    [onSuccess]
  );

  return (
    <>
      <ScreenInputFormFeature
        type={'text'}
        title={t('google_apple_sign_up.create_surname.title')}
        buttonText={t('auth.button.next')}
        defaultValue={user?.last_name}
        name={'last_name'}
        required={true}
        isFocus={true}
        isKeyboardShown={isKeyboardShown}
        isLoading={isLoading}
        onSubmit={handleSubmit}
      />
    </>
  );
};

export default memo(ProfileLastNameWidget);
